import { render, staticRenderFns } from "./i18n-toggle.vue?vue&type=template&id=2004a95a&"
import script from "./i18n-toggle.vue?vue&type=script&lang=js&"
export * from "./i18n-toggle.vue?vue&type=script&lang=js&"
import style0 from "./i18n-toggle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QIcon})
